import { render } from "./MultisidebarActions.vue?vue&type=template&id=c6b0243e&ts=true"
import script from "./MultisidebarActions.vue?vue&type=script&lang=ts"
export * from "./MultisidebarActions.vue?vue&type=script&lang=ts"

import "./MultisidebarActions.vue?vue&type=style&index=0&id=c6b0243e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__